export function validFileSize(field) {
    return field.files[0].size < parseInt(field.getAttribute("data-file-size"));
}
